import { AppConfigModel } from "../abstract/app-config.model";

export class OrganizationIdentifierType extends AppConfigModel {

    static override CLASS_NAME: string = 'OrganizationIdentifierType';
}
